export default {
  cancelOrderMap: {
    0: "Je ne le veux pas.",
    1: "Produit égaré",
    2: "Commande en double",
    3: "Échec de la réception",
    4: "Autres raisons",
  },
  "获取验证码": "Obtenir le code de vérification",
  "请输入验证码": "Veuillez entrer le code de vérification",
  "验证码":"Code de vérification",
  "发送":"Env",
  "已发送，请注意查收": "Envoyé, veuillez vérifier",
  "加值": "Ajouter de la valeur",
  "提领": "Retrait",
  "银行卡": "Carte bancaire",
  "联系商家": "Contacter le commerçant",
  "电商批发商场": "Marché de gros de commerce électronique",
  "请输入完整的支付密码!" : "Veuillez entrer le mot de passe de paiement complet!",
  "用户未发表评论": "L'utilisateur n'a pas commenté",
  "订单": "Commande",
  "平台人工发起退款": "Remboursement initié par le personnel de la plateforme",
  "下单成功，等待付款": "Commande passée avec succès, en attente de paiement",
  "下单成功，付款成功": "Commande passée avec succès, paiement réussi",
  "已发货，正在运输中": "Expédié, en cours de transport",
  "订单已取消，原因:手动发起取消订单": "La commande a été annulée. Raison : Annulez la commande manuellement.",
  "订单已取消，原因:超时自动取消订单": "La commande a été annulée. Raison : La commande sera automatiquement annulée après expiration du délai.",
  "商家已确认，已进入备货状态": "Le commerçant a été confirmé et est entré dans l'état de stock.",
  "系统发货成功": "La livraison du système a réussi",
  "订单已签收": "Ordre reçu",
  "发起退款申请": "Initier une demande de remboursement",
  "退款成功": "Remboursement réussi",
  "退款失败": "Échec du remboursement",
  "订单退款成功": "Remboursement de la commande réussi",
  "订单退款失败": "Le remboursement de la commande a échoué",
  "系统默认好评": "Le système propose par défaut des avis favorables",
  "请输入关键字搜索": "Veuillez entrer un mot-clé pour rechercher",
  "猜你喜欢": "Je suppose que tu aimes ça",
  "订单已完成": "La commande est terminée",
  "热销推荐": "Recommandation de vente à chaud",
  "头像选择": "Sélection d'avatars",
  "修改头像": "Modifier votre avatar",
  subOrder: "Soumettre la commande",
  "mailboxCheck": "Veuillez renseigner la bonne adresse e-mail",
  "switchLang": "Veuillez passer à une autre langue pour voir",
  "myCart": "Mon panier",
  "notQua": "Les conditions de qualification ne sont pas remplies.",
  "noSmaller": "Le montant appliqué ne peut être inférieur à",
  "nomax": "Le montant maximal de la demande ne peut pas dépasser",
  "evaluationUploading": "Vous avez encore des photos à télécharger. Veuillez réessayer plus tard",
  "evaluateInput": "Revue avec photos",
  "moneyOrderStatus": "Statut de la commande",
  "coinBlock": "Accord de change",
  "dealing": "En cours",
  "dealSuccess": "Réussi",
  "dealFail": "Échouer",
  "payCertificate": "Certificat de paiement",
  "handleFee": "Frais de service",
  "highOpinion": "Bonnes critiques",
  "mediumOpinion": "Avis moyen",
  "lowOpinion": "Mauvaises critiques",
  "hasImage": "Avec des photos",
  "rechargeMethod": "Mode recharge",
  "当前余额": "Solde actuel",
  "备注": "Remarque",
  "scanAndDown": "Scanner le code QR Télécharger l'application",
  "receivedAddress": "Adresse de réception",
  "ActualLedger": "Réception réelle",
  "view": "Voir",
  "withdrawNum": "Quantité de retrait d'espèces",
  "rechargeNum": "Quantité de recharge",
  "date": "Date",
  "walletHistory": "Historique du portefeuille",
  "accountBalance": "Solde du compte",
  "accountReview": "Aperçu du compte",
  "rated": "Révisé",
  "receiver": "Destinataire",
  "orderStatus": "Statut",
  "orderTime": "Temps",
  "tax": "Imposition",
  "discount": "Rabais",
  "productInfo": "Information produit",
  "paramError": "Erreur de paramètre",
  "orderInfo": "Informations sur la commande",
  "rebuy": "Encore une commande",
  "pleaseCorrectAddress": "Veuillez saisir la bonne adresse de retrait d'espèces",
  "pleaseInputCorrectNumber": "Veuillez entrer un nombre supérieur à 0",
  "vcodePass": "Vérification réussie !",
  "vcodeFail": "Authentification échouée. Veuillez réessayer",
  "uploading": "Téléchargement...",
  "uploadSuccess": "Le téléchargement a réussi",
  "uploadError": "Le téléchargement a échoué. Veuillez réessayer",
  "registerSuccess": "Inscription réussie",
  "pleaseSetMobileNumber": "Veuillez définir le numéro de téléphone",
  "unSelectedProduct": "Vous n'avez pas sélectionné de produit",
  "loginSuccess": "Connexion réussie",
  "pleaseSetAreaCode": "Entrez le nom du pays et l'indicatif régional pour rechercher",
  "login": "Connexion",
  "register": "Inscription",
  "logout": "Sortie",
  "noData": "Aucune donnée disponible",
  "search": "Recherche",
  "historySearch": "Recherche historique",
  "empty": "Vide",
  "home": "Page d'accueil",
  "favorableRate": "Taux de bons avis",
  "classification": "Catégorie",
  "searchTips": "Recherche source/produit/fournisseur/commande",
  "dailyNewArrival": "Nouveaux produits listés quotidiennement",
  "more": "Plus",
  "recommend": "Recommandation",
  "recommendedProducts": "Produits recommandés",
  "recommendedStore": "Magasins recommandés",
  "buyNow": "Achetez maintenant",
  "addCart": "Ajouter au panier",
  "complex": "Intégré",
  "price": "Prix",
  "retailPrice": "Prix ​​en détail",
  "originPrice": "Prix ​​d'origine",
  "service": "Service Clients",
  "collect": "Favoris",
  "sold": "Volume des ventes",
  "pageviews": "Quantité de navigation",
  "quantity": "Quantité",
  "freight": "Cargaison",
  "shipping": "Expédition",
  "ship": "Bateau",
  "buyTips": "Expédier dans les 24 heures après avoir passé la commande. Les commandes suivantes sont sous contrôle logistique et peuvent être expédiées en retard. Veuillez prêter attention aux informations logistiques ou contacter le service client.",
  "totalPrice": "Prix ​​total",
  "addCartMessage": "Ajouté au panier avec succès",
  "addCartMessageFaild": "Le produit existe déjà dans le panier.",
  "myAccount": "Mon qccount",
  "buyHistory": "Dossiers d'achat",
  "wishlist": "Produits favoris",
  "trackOrder": "Commande",
  "account": "Compte:",
  "sellerZone": "Espace marchand",
  "beSeller": "Devenir commerçant",
  "sellerPanelLogin": "Connexion marchand",
  "footTip": "© Copyright {name} Ltd 2024",
  "footTips": "{name} Limited est autorisé et réglementé par la Financial Conduct Authority en tant que courtier en crédit (713206) et traite exclusivement avec le prêteur Home Retail Group CardServices Limited en tant que {name} Financial Services. {name} Financial Services est autorisé et réglementé par la Financial Conduct Authority pour fournir du crédit (716148). Home Retail GroupCard Services Limited est enregistré au Royaume-Uni (04007072) à Avebury, 489-499 Avebury Boulevard, Milton Keynes, Royaume-Uni. MK9 2NW.",
  "item": "Article",
  "checkout": "Commander",
  "productDescription": "Description du produit",
  "userEvaluation": "Critiques d'utilisateurs",
  "AllProducts": "Tous les produits",
  "followers": "Suivre",
  "sales": "Volume des ventes",
  "visitStore": "Visitez le magasin",
  "authentic": "100% authentique",
  "dayReturns7": "7 jours de retour",
  "shippingDiscounts": "Remise sur le fret",
  "safePayment": "Paiement sécurisé",
  "followed": "Suivi",
  "dashboard": "Tableau de bord",
  "myOrder": "Ma commande",
  "setUp": "Installation",
  "successTips": "Réussi",
  "copySuccess": "Réplication réussie",
  "balance": "Solde (USDT)",
  "sort": "Taper",
  "commodity": "Produit",
  "browse": "Volume des ventes",
  "recharge": "Recharger",
  "commodityCollection": "Collecte de produits",
  "withdraw": "Retrait d'espèces",
  "defaultAddress": "Adresse par défaut",
  "addNewAddress": "Ajouter une nouvelle adresse",
  "withdrawRecord": "Registre des retraits d'espèces",
  "serialNumber": "N ° de commande.",
  "time": "Temps",
  "amount": "Montant",
  "processing": "En cours",
  "fail": "Échouer",
  "blockchainNetwork": "Réseau blockchain",
  "records": "Enregistrer",
  "withdrawAddress": "Adresse de retrait d'espèces",
  "withdrawInputTips": "Veuillez entrer l'adresse de retrait",
  "copy": "Réplication",
  "enterTips": "Entrez s'il vous plait",
  "actualAccount": "Compte réel",
  "handlingFee": "Frais de service",
  "confirm": "Confirmer la réception",
  "previous": "Étape précédente",
  "pleaseEnterAddress": "Veuillez entrer l'adresse",
  "pleaseEnterQuantity": "Veuillez entrer la quantité",
  "withdrawSuccess": "Commandes soumises avec succès",
  "saveQr": "Enregistrer le code QR",
  "pleaseEnterAmount": "Veuillez entrer le montant de la recharge",
  "expectedArrival": "Arrivée prévue",
  "currentRate": "Taux de change actuel",
  "uploadTips": "Preuve de paiement (télécharger une capture d'écran des détails de paiement)",
  "clickUpload": "Cliquez pour télécharger",
  "uploadPhoto": "Veuillez télécharger des photos",
  "rechargeSuccessful": "Recharge réussie",
  "rechargeTips": "\"Invite de recharge : \"\"Veuillez indiquer honnêtement le montant réel du transfert. Sinon, le système risque de ne pas réussir l'approbation et d'affecter la progression de la recharge.\"",
  "rechargeRecord": "Recharger l'enregistrement",
  "all": "Tous",
  "pending": "Être payé",
  "cancelled": "Annulé",
  "delivered": "À être expédié",
  "confirmed": "Confirmé",
  "receipt": "Être reçu",
  "harvested": "Reçu",
  "comment": "A vérifier",
  "refund": "Remboursement/après-vente",
  "cancelOrder": "Annuler la commande",
  "cancelReason": "Raison pour l'annulation",
  "cancelOrderTitle": "Veuillez sélectionner un motif d'annulation de commande",
  "returnOrderTitle": "Veuillez sélectionner le motif du retour",
  "refundInstructions": "Instructions de remboursement",
  "returnDetailTips": "Merci de donner votre avis sur le produit",
  "cancel": "Annuler la commande",
  "cancelOrder1": "Produit non reçu",
  "cancelOrder2": "Je n'aime pas ça, je ne le veux pas",
  "cancelOrder3": "Le vendeur a expédié les mauvaises marchandises",
  "cancelOrder4": "Fausse marque",
  "cancelOrder5": "Moins d'expédition, expédition manquée",
  "cancelOrder6": "Produit reçu endommagé",
  "cancelOrder7": "Il y a un problème de qualité",
  "cancelOrder8": "Négocier le remboursement avec le commerçant",
  "cancelOrder9": "Autres raisons",
  "cancelOrderSuccess": "Commande annulée avec succès",
  "returnOrderSuccess": "Soumettre avec succès",
  "orderName": "Nom",
  "orderEmail": "E-mail",
  "orderAddress": "Adresse",
  "orderNation": "Pays",
  "orderState": "Statut",
  "orderCity": "Ville",
  "orderPostCode": "Code Postal",
  "orderAmount": "Quantité",
  "orderPrefix": "Commande totale",
  "orderFee": "Impôts",
  "orderSpecification": "spécification",
  "orderCommodity": "Produit",
  "orderQuantity": "Quantité",
  "orderUnitprice": "Prix ​​unitaire",
  "orderFreight": "Cargaison",
  "orderTax": "Impôt",
  "orderTotal": "Total",
  "PaymentOrder": "Ordre de paiement",
  "Evaluate": "Examen",
  "CancelOrder": "Annuler la commande",
  "RemindShip": "Rappeler pour l'expédition",
  "Refund": "Remboursement",
  "Submitareview": "Soumettre des avis",
  "Information": "Information",
  "wrongPassword": "Erreur de mot de passe plus de 3 fois. Veuillez réessayer demain.",
  "Operate": "Opération",
  "Item": "Articles)",
  "From": "Depuis",
  "hint": "Conseils",
  "CheckDetails": "Voir les détails",
  "Payment": "Paiement",
  "Cancel": "Annuler",
  "refundSuccessfully": "Remboursement réussi",
  "pendingPayment": "Être payé",
  "pay": "Paiement",
  "LoginPassword": "Mot de passe",
  "sure": "Bien sûr",
  "shippingAddress": "Adresse de réception",
  "pleaseAddShippingAddress": "Veuillez d'abord ajouter une adresse de livraison",
  "transactionPassword": "Mot de passe transactionnel",
  "markDefaultAddress": "Marquer comme adresse de livraison par défaut",
  "edit": "Édité par",
  "delete": "Supprimer",
  "Opt": "Sélectionner",
  "piece": "pièces",
  "orderDetails": "Détails de la commande",
  "shopCollection": "Ajouter le magasin aux favoris",
  "addAddress": "Ajouter une nouvelle adresse",
  "signUp": "Inscription",
  "loginTips": "Vous avez déjà un compte?",
  "loginIn": "Connexion",
  "mobile": "Pas de téléphone",
  '购物车还没有商品': "Le panier n'a pas encore de produits",
  '去购物': "Aller faire du shopping",
  "modifyAddress": "Modifier l'adresse",
  "desc": "Définir comme adresse par défaut",
  "keep": "Maintenir",
  "onlineService": "Services en ligne",
  "send": "Envoyer",
  "EsShop": "Boutique en ligne",
  "desc3": "Entrez le mot de passe de la transaction",
  "desc4": "Entrez votre mot de passe transactionnel",
  "desc6": "Entrez à nouveau votre mot de passe de transaction",
  "setUpPayPaw": "Définir le mot de passe de la transaction",
  "setSuccess": "La configuration a réussi",
  "confirmPayPaw": "Confirmer le mot de passe de la transaction",
  "paymentSuccessful": "Paiement réussi",
  "paymentPending": "Paiement en attente",
  "paymentPendingDesc": "Votre paiement est en cours de traitement. Veuillez vérifier l'état de votre commande plus tard",
  "desc5": "Mauvaise adresse de livraison ? Contact",
  "customeService": "Service client en ligne",
  "BackHome": "Retour à la page d'accueil",
  "Checkorder": "Voir l'ordre",
  "ForgotPassword": "Mot de passe oublié ?",
  "signIn": "Connexion",
  "noAccount": "Pas de numéro de compte ?",
  "pleaseEnterAccount": "Veuillez entrer le numéro de compte",
  "pleaseEnterPassword": "Veuillez entrer le mot de passe",
  "password": "Mot de passe",
  "mobilePhone": "Numéro de téléphone",
  "pleaseEnterPhoneNumer": "Veuillez définir le numéro de téléphone",
  "setPassword": "Définir le mot de passe",
  "noDataFound": "Aucune donnée disponible",
  "searchCountry": "Entrez le nom du pays et l'indicatif régional pour rechercher",
  "pleaseEnterEmail": "Veuillez définir la boîte aux lettres",
  "invitationCode": "Code d'invitation",
  "plaeseEnterInvitaionCode": "Veuillez définir le code d'invitation",
  "pleaseSetLoginPassword": "Veuillez définir le mot de passe de connexion",
  "selectDeliveryAddress": "Sélectionnez l'adresse de livraison",
  "totalOf": "Total",
  "items": "Article",
  "orderSummary": "Récapitulatif de la commande",
  "paymentMethod": "Mode de paiement",
  "Balance": "Équilibre",
  "payPal": "Pay Pal",
  "notOpen": "Ce moyen de paiement n'est pas encore ouvert dans votre région",
  "mastercard": "MasterCard",
  "additional": "Supplémentaire",
  "handlingfee": "Frais de service requis",
  "goodsNumber": "Quantité de produits",
  "deliveryFee": "Fret",
  "totalNum": "Total",
  "new": "Nouveau",
  "oldPassword": "Ancien mot de passe",
  "pleaseEnterOldPassword": "Veuillez entrer l'ancien mot de passe",
  "newPassword": "Nouveau mot de passe",
  "plaseeEnterNewPassword": "Veuillez entrer le nouveau mot de passe",
  "confirmPassword": "Confirmez le mot de passe",
  "plaseeENterConfirmPassword": "Veuillez entrer le mot de passe de confirmation",
  "twoPawword": "Deux mots de passe ne sont pas identiques",
  "rechargeAddress": "Adresse de recharge",
  "plaseEnterRechargeAddress": "Veuillez entrer l'adresse de recharge",
  "userCenter": "Centre personnel",
  "merchantSettled": "Entrée marchand",
  "upNew": "Nouveau produit répertorié",
  "balanceNot": "L'équilibre ne suffit pas. Veuillez recharger.",
  "NoProductSelected": "Produit pas encore sélectionné",
  "ShippingAddressNotSet": "Adresse de livraison non définie",
  "consigneeName": "Nom du destinataire",
  "email": "E-mail:",
  "areaCode": "Indicatif régional international",
  "phoneNumber": "Numéro de téléphone",
  "nation": "Pays",
  "state": "Province/État/État",
  "city": "Ville",
  "postCode": "Code Postal",
  "address": "Adresse détaillée",
  "addAddressOrModifyAddress": "Ajouter une nouvelle adresse/Modifier l'adresse",
  "setAsTheDefaultAddress": "Définir comme adresse par défaut",
  "proceed": "Continuer",
  "btnSure": "Confirmer",
  "pleaseInput": "Entrez s'il vous plait",
  "allProduct": "Tous les produits",
  "myCommodityCollection": "Produits favoris",
  "myFollowedShops": "Suivez le magasin",
  "mySold": "Vendu",
  "myPageviews": "Quantité de navigation",
  "myPraiseRate": "Taux de bons avis",
  "myUnfollow": "Ne plus suivre",
  "inputNum": "Nombres",
  "inpuEmailErro": "Veuillez saisir la bonne adresse e-mail",
  "goodsShip": "Expédition",
  "goodsShipTips": "Les produits seront expédiés dans les 24 heures suivant la passation de la commande. Si le contrôle logistique existe pour la commande suivante, la commande peut être retardée. Veuillez prêter attention aux informations logistiques de la commande ou contacter le service client.",
  "goodsFreight": "Fret",
  "goodsFreeShipping": "Gratuit",
  "goodsFreightTips1": "1. Composition du fret transfrontalier des produits : fret = frais d'expédition + fret longue distance + frais de livraison",
  "goodsFreightTips2": "2. Si les conditions d'affranchissement ne sont pas remplies, le fret sera facturé selon les conditions réelles.",
  "goodsFreightTips3": "3. Le droit d'interprétation finale appartient à la plate-forme.",
  "pleaseValidPostCode": "Veuillez entrer plus de 4 chiffres",
  "pleaseValidEmail": "Veuillez saisir la bonne adresse e-mail",
  "pleaseValidPhone": "Veuillez entrer le bon numéro de téléphone",
  "productAvailable": "Ce produit a été retiré",
  "validatorMaxNumber": "Le montant dépasse la limite",
  "validatorRequire": "Les éléments requis ne peuvent pas être nuls",
  "validatorPhone": "Veuillez entrer le bon numéro de téléphone",
  "validatorEmail": "Veuillez saisir le format d'e-mail correct",
  "validatorPassword": "Le mot de passe est composé de 6 à 12 chiffres ou lettres(contient des caractères spéciaux)",
  "validatorSixNumber": "Veuillez entrer 6 chiffres purs",
  "validatorFourMoreNumber": "Veuillez saisir une combinaison de 4 à 32 chiffres ou lettres",
  "validatorIpRule": "Format IP incorrect",
  "validatorChineseAndEnglish": "Chinois et anglais uniquement, entrez une plage : 8 à 64 caractères",
  "collectionSuccess": "Ajouter aux favoris avec succès",
  "followedSuccess": "Suivi réussi",
  "cancelSuccess": "Annulé réussi",
  "evaluateOrder": "Revue avec photos",
  "evaluateOrderPlaceholder": "Veuillez revoir les produits",
  "operationSuccess": "Opération réussie",
  "confirmReceiveGoods": "Confirmer ou non la réception du produit",
  "evaluateOrderSuccess": "Examen réussi",
  "yesterday": "Hier",
  "notLogin": "Vous n'êtes pas encore connecté.",
  "delAllHistoryRecord": "Voulez-vous vraiment supprimer tous les enregistrements de l'historique ?",
  "or": "Ou",
  "tipsRemindsText": "Le commerçant recevra un rappel après le rappel de l'envoi",
  "tipsRemindsCount": "Il ne peut être rappelé qu'une seule fois.",
  "tipsRemindsMerchant": "Rappeler aux marchands",
  "tipsRemindsSuccess": "Rappel réussi",
  "noCartTips": "Votre panier est vide. Commencez à magasiner.",
  "defaultRate": "Le système propose par défaut des avis favorables",
  "prevPage": "Page précédente",
  "nextPage": "Page suivante",
  "returnApply": "Demande de remboursement",
  "returnReason": "Motif du remboursement",
  "returnAmount": "Montant du retour",
  "returnRemark": "Instructions de retour",
  order: {
    cancel: "Annuler la commande",
    confirm: "Confirmer la réception",
    payment: "Payez maintenant",
    remind: "Rappeler pour l'expédition",
    return: "Demande de remboursement de produit",
    evaluate: "Révisez maintenant",
    logistics: "Voir la logistique",
    noRefund: "Non remboursé",
    refunding: "Remboursement en cours",
    refundSuccess: "Remboursement réussi",
    refundFail: "Échec du remboursement",
  },
  "remindTitle": "Rappeler pour l'expédition",
  "remindContent": "Une fois l'expédition rappelée, le commerçant recevra le rappel. Il ne peut être rappelé qu'une seule fois.",
  "remindSuccess": "Rappel réussi",
  "remindRepeat": "Cette commande a été rappelée.",
  "noComments": "Pas d'avis pour le moment",
  "storeSeach": "Rechercher un produit dans ce magasin",
  "storeSeachTips1": "Trouvé pour vous",
  "storeSeachTips2": "Magasins associés trouvés",
  "storeSeachTips3": "Maison",
  "creditTit": "Services de crédit",
  "getCoupons": "Obtenez plus de coupons",
  "yourEmail": "Votre adresse e-mail",
  "subscription": "Abonnements",
  "paymethods": "Mode de paiement",
  "footdec": "Les utilisateurs du site mondial {name} viennent de {num} pays à travers le monde et utilisent {coin} pour le règlement. L'{coin} est une transaction sans frontières qui permet des transactions immédiates et à faible coût dans le monde entier, sans attente ni frais internationaux.",
  "custService": "Service Clients",
  "helpLine": "Service client en ligne",
  "contactUs": "Contactez-nous",
  "partner": "Fournisseurs coopératifs",
  "buyRules": "Règles de l'acheteur",
  "sellerRules": "Politique du vendeur",
  "returnsAndEx": "Retours et échange",
  "servicePolicy": "Politique de service",
  "returnPolicy": "Politique de retour",
  "user_Center": "Centre utilisateur",
  "userReg": "Enregistrement de l'utilisateur",
  "orderTrack": "Demande de commande",
  "purchageHistory": "Historique d'achat",
  "myPurse": "Mon portefeuille",
  "aboutUs": "À propos de nous",
  "Recruitment": "Attendez les personnes talentueuses",
  "news": "Informations sur l'actualité",
  "stateMent": "Déclaration sur l'esclavage moderne",
  "binance": "Binance",
  "huobi": "Houbi",
  "okx": "d'accord",
  "客户端下载": "Télécharger le client",
  "提现方式": "Méthode de retrait",
  "metaMask": "Métamasque",
  "homeBannertips1": "Devenir commerçant",
  "homeBannertips2": "Commission totale",
  "homeBannertips3": "Max.",
  "homeBannerbtn": "Adhérer maintenant",
  "homeDownloadtips1": "Centre commercial de gros e-commerce transfrontalier",
  "homeDownloadtips2": "Offre spéciale de la marque",
  "homeDownloadtips3": "Remise non-stop",
  "homeDownloadtips4": "Téléchargement Android",
  "homeDownloadtips5": "Téléchargement Apple",
  "homeDownloadtips6": "Scannez le code QR pour télécharger l'application",
  "homeIconTips1": "100% authentique",
  "homeIconTips2": "7 jours de retour",
  "homeIconTips3": "Remise sur le fret",
  "homeIconTips4": "paiement sécurisé",
  "headerSearchTips": "Veuillez entrer un mot-clé pour rechercher",
  "collAccount": "Mode de prêt",
  "mine": "Exploiter.",
  "creditText1": "Les prêts de démarrage résolvent le problème d'emprunter de l'argent",
  "creditText2": "Fournir des services de prêt de démarrage et de rotation du capital",
  "creditWorry": "Prêt sans souci",
  "creditQuota": "Limite flexible",
  "creditQuotaINFO": "100 000 à 30 000 000 avec limite flexible et sans restriction, avec une durée de prêt maximale d'un an.",
  "quickLoan": "Prêt rapide",
  "creditReview": "Passez l'audit en une heure au plus tôt, si l'examen est réussi, le prêt sera débloqué tout de suite.",
  "safe": "Sûr et sans souci",
  "safeInfo": "Pas d'hypothèque, pas de caution, pas de rappel, car il s'agit en fait d'une affaire privée.",
  "about": "À propos de nous",
  "aboutText1": "\"Nous nous engageons à prêter des services financiers, basés sur la philosophie d'entreprise \"\"le client d'abord\"\", avons pour mission de résoudre le problème de la rotation des capitaux des clients. Depuis sa création, la société a aidé de nombreux clients à résoudre le problème de la rotation du capital.\"",
  "aboutText2": "Limite : 100 000 à 30 000 000, méthode de remboursement flexible à faible taux d'intérêt, sans frais initiaux, prêt en ligne, sans appel téléphonique pour vérification, informations confidentielles et prêt le jour même.",
  "contactUs1": "Si vous ne souhaitez pas emprunter d'argent à vos camarades de niveau, veuillez nous contacter.",
  "committed": "Engagement envers les services de prêt aux entrepreneurs",
  "financial": "Répondez à vos préoccupations financières",
  "partnersTit": "Plateforme de prêt en ligne partenaire",
  "application": "Demande de prêt",
  "applicant": "Demandeur",
  "actualName": "Vrai nom",
  "yourName": "Veuillez entrer le nom",
  "term": "Durée du prêt",
  "applicationAmount": "Quantité exigée",
  "rates": "Taux d'intérêt du prêt",
  "loanMethod": "Mode de prêt",
  "accountB": "Solde du compte",
  "countryOf": "Nationalité",
  "myloan": "Mon prêt",
  "applyLoan": "Demander un prêt",
  "loaned": "Prêté",
  "interest": "Intérêts courus",
  "esRepayment": "Remboursement estimé",
  "loanHistory": "Dossier de prêt",
  "applicantDate": "Date de la demande",
  "repayment": "Remboursement",
  "cycle": "Cycle de remboursement",
  "fixedRate": "Taux d'intérêt fixe",
  "successLoan": "Prêt réussi",
  "Reapply": "Réappliquer",
  "borrow": "Échec du prêt",
  "applicantIn": "Candidature en cours",
  "repaid": "Remboursement",
  "overdue": "En retard",
  "estirepay": "Remboursement estimé",
  "loanDays": "Nombre de jours prêtés",
  "reAmount": "Montant du remboursement",
  "repay": "Mode de remboursement",
  "entRepay": "Confirmer le remboursement",
  "foryourmoney": "Si vous êtes en manque de fonds, ne trouvez nulle part où emprunter de l'argent ou êtes gêné d'emprunter de l'argent à vos amis, vous pouvez nous contacter. Nous avons tout le processus de service professionnel pour répondre à vos doutes à tout moment. Notre objectif est de rendre chaque prêt transparent, afin que les clients puissent l'utiliser rapidement et en toute confiance.",
  "onlineApplin": "Postuler en ligne",
  "businessloan": "Demande de prêt de démarrage",
  "selectCountry": "Veuillez sélectionner une nationalité",
  "selectPeriod": "Veuillez sélectionner une période",
  "passPortImg": "N° d'identité/N° de passeport",
  "uploadId": "Téléchargement de photo de certificat/passeport",
  "readAndAgree": "J'ai lu et accepté",
  "loanAgree": "Accord de prêt",
  "submitApplica": "Dépôt de candidature",
  "photoExample": "Exemple de prise de photos",
  "discounted": "Produits à prix réduit",
  "days": "jour",
  "privacyPolicy": "Politique de confidentialité",
  "delivery": "Livraison et ramassage",
  "checkAgreement": "Veuillez cocher l'accord !",
  "businessPhone": "Téléphone de travail",
  "businessEmail": "Messagerie d'entreprise",
  "加密货币": "Cryptomonnaie",
  "银行卡": "Carte bancaire",
  "充值币种": "Monnaie de recharge",
  '参数缺失': "Paramètre manquant",
  '充值数量必填': "Le montant de la recharge est requis",
  "充值金额": "Montant de la recharge",
  "充值金额不得小于": "Le montant de la recharge ne peut pas être inférieur à",
  "充值金额不得大于": "Le montant de la recharge ne peut pas être supérieur à",
  "请先选择币种": "Veuillez d'abord sélectionner la monnaie",
  "开户行": "Banque",
  "请输入开户行名称": "Veuillez entrer le nom de la banque",
  "银行卡号": "Numéro de carte bancaire",
  "请输入银行卡号": "Veuillez entrer le numéro de carte bancaire",
  "点击去支付": "Cliquez pour payer",
  "企业证明": "Certificat d'entreprise",
  "提交失败": "La soumission a échoué",
  "充值金额不能小于1": "Le montant de la recharge ne peut pas être inférieur à 1 (y compris deux décimales)",
  "请切换其他语言后查看": "Veuillez passer à une autre langue pour voir",
  "我的购物车": "Mon panier",
  "推荐商品": "Produits recommandés",
  "猜你喜欢": "Je suppose que vous l'aimez.",
  "暂无店铺": "Aucun magasin trouvé",
  "添加失败": "Échec de l'envoi. Veuillez réessayer plus tard",
  "提交订单": "Soumission de la commande",
  recommendclass:"Recommander la catégorie",
  "最多包含10位小数": "Jusqu'à 10 décimales",
  "企业电话": "Téléphone de l'entreprise",
  "职业机会": "Chance d'emploi",
  "滑动验证":"Faites glisser le curseur pour vérifier",
  "长时间未付款，系统自动取消订单": "Si vous ne payez pas pendant une longue période, le système annulera automatiquement la commande",
  "最多上传9张图片":"Jusqu'à 9 photos peuvent être téléchargées",
  "账号注销":"annulation de compte",
  "确定注销":"confirmer la déconnexion",
  "您的账号":"Votre compte",
  "为什么要离开":"Pourquoi es-tu parti",
  "您还有余额,不能注销账号":"Vous avez encore du solde, impossible d'annuler le compte",
  "请输入注销理由":"Veuillez saisir un motif d'annulation",
  "您确认要注销吗?":"Êtes-vous sûr de vouloir vous déconnecter?",
  "我再考虑下": "Laat ek weer daaroor dink",
  "同意注销": "Stem in om uit te meld",
  "注销成功":"Afmeld suksesvol",
  "cancelInfo":"avertir! Veuillez faire attention à annuler le compte. Si vous n'utilisez plus le compte, vous pouvez cliquer sur [Accepter l'annulation]. Vous ne pourrez peut-être pas vous inscrire quelques jours après l'annulation.",
  "App下载(买家端)": "Téléchargement d'application (vendeur)",
  "App下载(卖家端)":"Téléchargement d'application (acheteur)",
  "请选择": "Choisissez s'il vous plaît",
  "提款地址绑定": "Adresse de retrait obligatoire",
  "绑定成功": "lier avec succès",
  "仅能绑定一个收款地址!": "Une seule adresse de réception peut être liée !",
  footTipTikTok:"CoveBuy ©️2024 Droit d'auteur",
  TikTokFoot:"CoveBuy est une plate-forme sociale mondiale de courtes vidéos CoveBuy et la plus grande société de commerce de gros d'Asie, Alibaba, établie en coopération. Il s'agit d'une plate-forme mondiale de commerce électronique et possède trois entrepôts intelligents autonomes dans le monde, situés à Toronto, au Canada, à Los Angeles et à Chiba, au Japon. Les produits en vente dans l'application incluent des produits populaires du Japon, de Corée du Sud, de Chine et d'autres pays asiatiques. À l'heure actuelle, le nombre total a dépassé 50 000 et continue de croître rapidement.",
  "betaBannerText": "Le site est en test public, veuillez ne pas passer de commandes"
}